import { Component, computed, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HOURNAMES_MAP, HOURS_ET, UrlService } from '@eforall/common';
import { BlockoutSlots, DAY_INDICES, SelectedSlots, SLOTS_DAY_MAP, StandardFourTimeZoneId } from '@interfaces';


@Component({
	selector: 'schedule-table-part',
	standalone: true,
	templateUrl: './schedule-table.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./schedule-table.part.scss'],
})

export class ScheduleTablePart implements OnInit {

	public selectedSlots = input.required<SelectedSlots | undefined>();
	public blockoutSlots = input<BlockoutSlots[]>([]);
	public timeZoneId = input.required<StandardFourTimeZoneId>();

	public commonLabels = inject(UrlService).commonLabels;

	dayIndices = DAY_INDICES;
	public selectedSlotsArr: boolean[][] = Array(this.dayIndices.length).fill(null).map(() => Array(HOURS_ET.length).fill(false))
	public disabledArr: boolean[][] = Array(this.dayIndices.length).fill(null).map(() => Array(HOURS_ET.length).fill(false));

	public hourNames = computed<string[]>(() => {
		const timeZoneId = this.timeZoneId();
		const hourNames = HOURNAMES_MAP[timeZoneId]!;
		return hourNames;
	});

	ngOnInit() {
		this.setSelectedSlotsArr();

		// disabling accelerator Schedule slots and updating selectedSlotsArr with accSchedule selection
		this.blockoutSlots().forEach(s => {
			const { dayIndex, startTimeIndex, applicantSelectedAccSlot } = s;

			if (this.disabledArr[dayIndex]) {
				this.disabledArr[dayIndex][startTimeIndex] = true;
			}
			if (this.selectedSlotsArr[dayIndex]) {
				this.selectedSlotsArr[dayIndex][startTimeIndex] = applicantSelectedAccSlot
			}
		})

	}

	setSelectedSlotsArr() {
		const selectedSlots = this.selectedSlots();
		if (!selectedSlots) return;
		this.dayIndices.forEach(dayIndex => {
			const dayArray = this.selectedSlotsArr[dayIndex];
			if (!dayArray) return;

			const dayKey = SLOTS_DAY_MAP[dayIndex];
			const scheduleString = selectedSlots[dayKey];
			for (let i = 0; i < scheduleString.length; i++) {
				dayArray[i] = scheduleString[i] !== '-';
			}
		})
	}
}